import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка объявлений
    async getJobPostings(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.start_opened_date) {
        const serverDate = this.getDateToServer(data.start_opened_date).toISOString();
        params.set("start_opened_date", serverDate);
      }

      if (data.end_opened_date) {
        const serverDate = this.getDateToServer(data.end_opened_date).toISOString();
        params.set("end_opened_date", serverDate);
      }

      if (data.start_closed_date) {
        const serverDate = this.getDateToServer(data.start_closed_date).toISOString();
        params.set("start_closed_date", serverDate);
      }

      if (data.end_closed_date) {
        const serverDate = this.getDateToServer(data.end_closed_date).toISOString();
        params.set("end_closed_date", serverDate);
      }

      if (data.locations) {
        data.locations.forEach(id => {
          params.append("locations[]", id);
        });
      }

      if (data.status) {
        params.set("status", data.status);
      }

      if (data.provider_id) {
        params.set("provider_id", data.provider_id);
      }

      if (data.assigned) {
        data.assigned.forEach(id => {
          params.append("assigned[]", id);
        });
      }

      if (data.vacancies) {
        data.vacancies.forEach(id => {
          params.append("vacancies[]", id);
        });
      }

      return await this.get(`job_postings?${params.toString()}${sorting}`);
    },
    // Получение рекрутингового объявления по id
    async getJobPostingById(id) {
      return await this.get(`job_postings/id/${id}`);
    },
    // Создание рекрутингового объявления
    async postJobPosting(data) {
      return await this.post('job_postings', data);
    },
    // Изменение рекрутингового объявления
    async putJobPosting(data) {
      return await this.put(`job_postings/id/${data.id}`, data);
    },
    // Удаление рекрутингового объявления
    async deleteJobPosting(data) {
      return await this.delete(`job_postings/id/${data.id}`, null);
    },

    /* Responses */

    async getResponses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.job_posting_id) {
        params.set("job_posting_id", data.job_posting_id);
      }

      if (data.assigned) {
        data.assigned.forEach(id => {
          params.append("assigned[]", id);
        });
      }

      if (data.recruit_task_id) {
        params.set("recruit_task_id", data.recruit_task_id);
      }

      if (data.worker_id) {
        params.set("worker_id", data.worker_id);
      }

      if (data.status) {
        params.set("status", data.status);
      }

      return await this.get(`job_postings/responses?${params.toString()}${sorting}`);
    },
    async getResponseById(id) {
      return await this.get(`job_postings/responses/id/${id}`);
    },
    async postResponse(data) {
      return await this.post('job_postings/responses', data);
    },
    async putResponse(data) {
      return await this.put(`job_postings/responses/id/${data.id}`, data);
    },
    async deleteResponse(data) {
      return await this.delete(`job_postings/responses/id/${data.id}`, null);
    },
    async claimResponse(responseId) {
      return await this.post(`job_postings/responses/id/${responseId}/claim`, {});
    },
    async linkResponseToWorker(responseId, workerId) {
      return await this.post(`job_postings/responses/id/${responseId}/link-worker`, {
        worker_id: workerId,
      });
    },
    async convertResponseToWorker(responseId, data) {
      return await this.post(`job_postings/responses/id/${responseId}/convert`, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/network/recruitJobPostings.js